import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== 'test') {
      console.error('ErrorBoundary caught an error', error, errorInfo);
    }
  }

  render() {
    const { children, label = 'This area' } = this.props;

    if (this.state.hasError) {
      return (
        <section
          role="alert"
          className="min-h-[240px] rounded-lg border border-white/10 bg-neutral-950 px-6 py-8 text-white shadow-lg"
        >
          <p className="text-sm font-semibold uppercase tracking-wide text-red-300">
            {label} unavailable
          </p>
          <h2 className="mt-3 text-2xl font-semibold">Something went wrong.</h2>
          <p className="mt-2 max-w-xl text-sm leading-6 text-neutral-300">
            This section could not be loaded. Try refreshing the page or contact support if the issue continues.
          </p>
        </section>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
